exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pay-in__created-payment[data-v-61500ca6] {\n  background: rgba(248, 212, 111, 0.25);\n  border-radius: 0.25rem;\n  padding: 0.5rem 0.75rem;\n}\n.pay-in__created-payment-actions[data-v-61500ca6] {\n  gap: 0.5rem;\n}\n.pay-in__add-method[data-v-61500ca6] {\n  color: #222c3c;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n.pay-in__add-method .add-circle[data-v-61500ca6] {\n    transform: scale(0.75);\n}\n.pay-in__add-method--disabled[data-v-61500ca6] {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-61500ca6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationPayIn/CreatedPartialPaymentList.vue
// module id = 2017
// module chunks = 0